// @flow

export default class Coordinates {
    latitude: ?number;
    longitude: ?number;
    latitudeDelta: ?number;
    longitudeDelta: ?number;

    constructor(args: ?Object = {}) {
        this.latitude = isNaN(parseFloat(args.latitude)) ? null : parseFloat(args.latitude);
        this.longitude = isNaN(parseFloat(args.longitude)) ? null : parseFloat(args.longitude);
        this.latitudeDelta = isNaN(parseFloat(args.latitudeDelta)) ? 0.0922 : parseFloat(args.latitudeDelta);
        this.longitudeDelta = isNaN(parseFloat(args.longitudeDelta)) ? 0.0421 : parseFloat(args.longitudeDelta);
    }

    static create(args: ?Object = {}): Coordinates {
        return JSON.parse(JSON.stringify(new Coordinates(args || {})));
    }
}